import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { 
    checkUrl: String,
    clientName: String
  }

  async confirmDelete(event) {
    event.preventDefault()
    const link = event.currentTarget
    
    try {
      // Check deletion status first
      const response = await fetch(this.checkUrlValue)
      const data = await response.json()
      
      if (!data.can_delete) {
        alert(data.message)
        return
      }
      
      // Build confirmation message
      let confirmMessage = `Are you sure you want to delete "${this.clientNameValue}"?\n\n`
      
      if (data.will_be_permanent) {
        confirmMessage += "⚠️ This action is PERMANENT and cannot be undone.\n"
        confirmMessage += "The client has no relationships and will be completely removed from the system."
      } else {
        confirmMessage += "⚠️ This client has existing relationships:\n"
        if (data.relationships && data.relationships.length > 0) {
          data.relationships.forEach(rel => {
            confirmMessage += `  • ${rel}\n`
          })
        }
        confirmMessage += "\nThe client will be ARCHIVED instead of permanently deleted."
      }
      
      confirmMessage += "\n\nDo you want to proceed?"
      
      // Show confirmation dialog
      if (confirm(confirmMessage)) {
        // Create a form and submit it with DELETE method
        const form = document.createElement('form')
        form.method = 'POST'
        form.action = link.href
        
        // Add Rails CSRF token
        const token = document.querySelector('meta[name="csrf-token"]')?.content
        if (token) {
          const csrfInput = document.createElement('input')
          csrfInput.type = 'hidden'
          csrfInput.name = 'authenticity_token'
          csrfInput.value = token
          form.appendChild(csrfInput)
        }
        
        // Add method override for DELETE
        const methodInput = document.createElement('input')
        methodInput.type = 'hidden'
        methodInput.name = '_method'
        methodInput.value = 'delete'
        form.appendChild(methodInput)
        
        document.body.appendChild(form)
        form.submit()
      }
    } catch (error) {
      console.error('Error checking deletion status:', error)
      // Fallback to simple confirmation
      if (confirm(`Are you sure you want to delete "${this.clientNameValue}"? This action may be permanent.`)) {
        window.location.href = link.href
      }
    }
  }
}